import DesignEditorControls from './DesignEditorControls';
import DesignEditorPrimaryControls from './components/DesignEditorPrimaryControls';
import DesignEditorSecondaryControls from './components/DesignEditorSecondaryControls';
import DesignEditorAuxiliaryControlBar from './components/DesignEditorAuxiliaryControlBar';

export {
  DesignEditorPrimaryControls,
  DesignEditorSecondaryControls,
  DesignEditorAuxiliaryControlBar,
};
export default DesignEditorControls;
